import ItemShop from "./ItemShop";

/*
    Contains the logic behind a shop.
*/
export default class Shop {
    
    constructor(public Items: Array<ItemShop>) {

    }
}